import * as crypto from 'crypto-js';

export default () => {
  return crypto.lib.WordArray.random(50);
}
